import { cloneWithoutKeys } from 'Utils/objects'
import initialState from 'Checkout/Redux/InitialState'

let DetailsReducer

(() => {
  const DETAILS_KEYS_TO_IGNORE = ['allowMarketing', 'firstName', 'lastName', 'email', 'phone']

  DetailsReducer = (currentState = {}, { type, payload }) => {
    const handler = detailsHandlers[type]
    if (handler) return handler(currentState, payload)

    return currentState
  }

  const detailsClear = currentState => {
    const newState = cloneWithoutKeys(initialState.details, DETAILS_KEYS_TO_IGNORE)
    const state = { ...currentState, ...newState }

    return state
  }

  const detailsSetData = (currentState, payload = {}) => ({
    ...currentState,
    ...payload,
  })

  const detailsSetError = (currentState, payload = false) => ({
    ...currentState,
    isError: payload,
  })

  const detailsValidateNewFields = (currentState, payload = {}) => {
    const { guests: { adults, children, pets, petBreeds, vehicles, vehiclesTowed } } = currentState
    const { guests: guestsValidations } = payload
    const adultsValidated = guestsValidations.adults.max === 0 ? 0 : adults
    const childrens = guestsValidations.children ? children : 0
    const petFields = guestsValidations.pets ? { pets, petBreeds } : { pets: 0, petBreeds: '' }
    const vehicleFields = guestsValidations.extraVehicles ? { vehicles, vehiclesTowed } :
                                                            { vehicles: 0, vehiclesTowed: false }

    return {
      ...currentState,
      guests: {
        ...currentState.guests,
        ...petFields,
        ...vehicleFields,
        adults: adultsValidated,
        children: childrens,
      },
    }
  }

  const detailsToggleValidation = currentState => ({
    ...currentState,
    toggleValidations: !currentState.toggleValidations,
  })

  const detailsHandlers = {
    DETAILS_CLEAR: detailsClear,
    DETAILS_SET_DATA: detailsSetData,
    DETAILS_SET_ERROR: detailsSetError,
    DETAILS_TOGGLE_VALIDATIONS: detailsToggleValidation,
    DETAILS_VALIDATE_NEW_FIELDS: detailsValidateNewFields,
  }
})()
export default DetailsReducer
